var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dx-grid',{ref:"grid",attrs:{"url":_vm.url,"columns":_vm.columns,"title":_vm.title,"beforeSetupGrid":_vm.beforeSetupGrid,"expandedOptions":{
            enabled: true,
            template: 'student-call-details',
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }